import { SelectField } from "melco-shared-logic";
import { useTranslation } from "react-i18next";

const OPERATORS = ["equal", "not_equal", "contains", "not_contains"];

type SelectOperatorProps = {
  name: string;
};

export const SelectOperator: React.FC<SelectOperatorProps> = ({ name }) => {
  const { t } = useTranslation();

  return (
    <SelectField
      name={name}
      style={{ width: "100%" }}
      options={OPERATORS.map((operatorId) => ({
        label: t(
          `designMappings.actions.processingConditions.operator.${operatorId}`
        ),
        value: operatorId,
      }))}
    />
  );
};
